module.exports = __webpack_public_path__ + "media/newstyle/images/icon-seu-livro-red-8856e48c8da84acc5de2f0cd83a83f1e.png";